var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { v4 as uuid } from 'uuid';
import { container } from 'tsyringe';
import { FormTemplate } from 'packages/form/entities/FormTemplate';
import { LanguageService } from 'services/LanguageService';
import { CompanyService } from 'packages/company/CompanyService';
import VueI18n from 'vue-i18n';
var companyService = container.resolve(CompanyService);
var FormInitializer = /** @class */ (function () {
    function FormInitializer() {
    }
    FormInitializer.translateQuestions = function (formTemplate, i18n, company) {
        formTemplate.questions
            .forEach(function (question) {
            question.uuid = uuid();
            question.label = i18n.t(question.label, formTemplate.lang, { company: company ? company.name : '' });
            if (question.options) {
                question.options.forEach(function (option) {
                    option.label = i18n.t(option.label, formTemplate.lang);
                });
            }
        });
        return formTemplate;
    };
    FormInitializer.translateDefaultFields = function (formTemplate, i18n, company) {
        formTemplate = this.translateQuestions(formTemplate, i18n, company);
        return formTemplate;
    };
    FormInitializer.initializeFormFromTemplate = function (template, jobName, lang, company) {
        return __awaiter(this, void 0, Promise, function () {
            var i18n, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        i18n = container.resolve(VueI18n);
                        if (!(company !== null && company !== void 0)) return [3 /*break*/, 1];
                        _a = company;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, companyService.getCurrentCompany()];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        company = _a;
                        if (!template.name) {
                            template.name = i18n.t('form.default_form_name', lang);
                            if (template instanceof FormTemplate) {
                                template.name = i18n.t('form.default_form_template_name');
                            }
                        }
                        if (template.welcome) {
                            template.welcome.title = i18n.t(template.welcome.title, {
                                company: company === null || company === void 0 ? void 0 : company.name,
                                job: jobName,
                            });
                            template.welcome.subtitle = i18n.t(template.welcome.subtitle);
                        }
                        template.lang = lang !== null && lang !== void 0 ? lang : container.resolve(LanguageService).currentLanguage;
                        this.translateDefaultFields(template, i18n, company);
                        template.results.forEach(function (result) {
                            var _a, _b;
                            result.title = (_a = i18n.t(result.title, template.lang)) !== null && _a !== void 0 ? _a : i18n.t('form.question_defaults.result.title', template.lang);
                            result.description = (_b = i18n.t(result.description, template.lang)) !== null && _b !== void 0 ? _b : i18n.t('form.question_defaults.result.description', template.lang);
                        });
                        return [2 /*return*/, template];
                }
            });
        });
    };
    return FormInitializer;
}());
export { FormInitializer };
